function StatusPill({ type }) {
  const config = {
    I: { label: 'Ingreso', tone: 'emerald' },
    E: { label: 'Egreso', tone: 'rose' },
    A: { label: 'Ahorro', tone: 'amber' },
  };
  const fallback = { label: '—', tone: 'slate' };
  const { label, tone } = config[type] ?? fallback;

  const tones = {
    emerald: 'bg-emerald-400/10 text-emerald-300/90 ring-emerald-300/20',
    rose: 'bg-rose-400/10 text-rose-300/90 ring-rose-300/20',
    amber: 'bg-amber-400/10 text-amber-300/90 ring-amber-300/20',
    slate: 'bg-white/5 text-white/50 ring-white/10',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-mono uppercase tracking-[0.14em] ring-1 ${tones[tone]}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}

export default StatusPill;